/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const ADD_SUBSCRIPTIONS = 'Add API Subscriptions';
export const BACK = 'Back';
export const SUBSCRIBE = 'Subscribe';
export const SUBSCRIPTIONS = 'Subscriptions';
export const API_LIST = 'API List';
export const SELECTED = 'Selected';
export const DROPDOWN_WIDTH = 300;
export const DROPDOWN_MAX_HEIGHT = 350;
export const EMPTY_HEADER = 'No API available for subscription';
export const NAME = 'API Name';
export const VERSION = 'Version';
export const URI = 'URI';
export const MAX_APIS_SELECTION = 20;
export const RESTRICTION_MESSAGE = `${MAX_APIS_SELECTION} is the maximum limit for API subscription`;
export const RESTRICTION_MESSAGE_NEW = `You can select up to ${MAX_APIS_SELECTION} records at a time to subscribe. For more, please repeat the process.`;
export const ROWS_PER_PAGE_LABEL = 'Rows per page:';
export const UNSUCCESSFUL_SUBSCRIPTION_TITLE = 'Subscription unsuccessful';
export const UNSUCCESSFUL_SUBSCRIPTION_MESSAGE = 'Subscription was unsuccessful for these APIs:';
export const ERROR_MACHINE_NOT_FOUND = 'Machine not found';
export const API_SUBSCRIBED_SUCCESSFULLY = "API's subscribed successfully";
export const ERROR_WHILE_FETCHING_DATA = 'Error while fetching data: {0}';
export const SELECTED_OF = 'selected of';